const bypass = {
  toggleCallback: () => {},

  create() {
    const container = $('<div>').addClass('bypass-gate-container bypass-content-gate hide-small');
    const demoText = $('<div>').addClass('demo-text').text('Client Demo');
    const button = $('<button>')
      .addClass('bypass-gate-button')
      .text('Return to the gate')
      .on('click', () => {
        this.toggle(true);
      });

    container.append(demoText, button);
    return container;
  },

  addToTop() {
    const container = this.create();
    container.css('position', 'fixed');
    $('body').prepend(container);
  },

  toggle() {
    $('.bypass-content-gate').toggleClass('hide-small');
    this.toggleCallback();
  },
};

export default bypass;
